import type { StepperConfiguration } from './types';

export const getSteps = <StepId>(
    stepperConfiguration: StepperConfiguration<StepId>[],
    currentStepId?: StepId,
): string[] => {
    return stepperConfiguration.reduce((acc, { stepId, stepLabel, stepIndex }) => {
        // Don't show step in stepper
        if (stepIndex === false) {
            return acc;
        }

        // Use stepLabel if stepIndex isn't used yet
        if (!acc[stepIndex] && stepLabel) {
            acc[stepIndex] = stepLabel;
        }

        // Rewrite label with stepLabel if step is active
        if (currentStepId === stepId && stepLabel) {
            acc[stepIndex] = stepLabel;
        }

        return acc;
    }, [] as string[]);
};
